import { useCallback, useEffect, useState } from 'react';
import axiosInstance from '../services/axiosInterceptor';

export default function useStudyYearSelector({ defaultToLatest = false } = {}) {
  const [yearList, setYearList] = useState([]);
  const [yearId, setYearId] = useState(() => localStorage.getItem('yearId') || '');
  const [yearLabel, setYearLabel] = useState('');

  useEffect(() => {
    axiosInstance.get('/api/getStudyYear')
      .then(res => {
        const list = res.data || [];
        setYearList(list);
        let id = defaultToLatest ? list[0]?.year_id : localStorage.getItem('yearId');
        if (!id && list.length > 0) {
          id = list[0].year_id;
          localStorage.setItem('yearId', id);
        }
        setYearId(id || '');
        const selected = list.find(y => String(y.year_id) === String(id));
        setYearLabel(selected ? `ปีการศึกษา ${selected.year_year}` : '');
      })
      .catch(() => {});
  }, [defaultToLatest]);

  const handleSelectYear = useCallback((id) => {
    const selected = yearList.find(y => String(y.year_id) === String(id));
    if (!selected) return;
    setYearId(id);
    setYearLabel(`ปีการศึกษา ${selected.year_year}`);
    localStorage.setItem('yearId', id);
  }, [yearList]);

  return { yearList, yearId, yearLabel, handleSelectYear };
}
